import { Overlay } from '@angular/cdk/overlay';
import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ModalContentWrapperComponent } from '../../components/modal-content-wrapper/modal-content-wrapper.component';
import { IModalConfig } from '../../models/layout/modal-config.interface';
import { IServiceResponseWidgets } from '../../models/services/response-app/response-app-widgets.interface';
import { StoreService } from '../store/store.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private storeService: StoreService, private zone: NgZone, private dialog: MatDialog, public overlay: Overlay) {
    // @ts-ignore
    window['openModal'] = (modalIdReference: string, config?: IModalConfig) =>
      this.zone.run(() => this.openModal(modalIdReference, config));
    // @ts-ignore
    window['closeModal'] = () => this.zone.run(() => this.closeModal());
  }
  /**
   * Finds modal tag reference
   * Open modal component with microfrontend reference
   * @param modalIdReference Modal id reference that should match modal mfe content
   * @param modalConfig Layout configuration infos
   */
  openModal(modalIdReference: string, config?: IModalConfig) {
    let data: IServiceResponseWidgets;

    this.storeService.widgetList.subscribe((widgetList) => {
      for (const modalItem of widgetList) {
        if (modalIdReference !== modalItem.tag_html) {
          continue;
        }
        data = modalItem;
        data.titulo_modal = config?.titulo;
      }

      this.dialog.open(ModalContentWrapperComponent, {
        height: config?.altura ? `${config.altura}px` : '',
        width: config?.largura ? `${config.largura}px` : '',
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        data,
        disableClose: true,
        hasBackdrop: true,
        scrollStrategy: this.overlay.scrollStrategies.noop(),
        ariaLabel: `Modal ${data.titulo_modal ? data.titulo_modal : ''}`,
        panelClass: './../components/modal-content-wrapper/modal-content-wrapper.component'
      });
    });
  }

  /** Returns as max modal height the height of user's screen  */
  get maxHeight() {
    return `${document.documentElement.clientHeight}px`;
  }

  /** Returns as max modal width 70% of the width user's screen  */
  get maxWidth() {
    return `${document.documentElement.clientWidth * 0.7}px`;
  }

  closeModal() {
    this.dialog.closeAll();
  }
}
